import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
var getGenomeById = function getGenomeById(genomeId) {
  return function (state) {
    var _state$genomes$custom, _state$genomes, _state$genomes2;
    return (_state$genomes$custom = (_state$genomes = state.genomes) === null || _state$genomes === void 0 ? void 0 : _state$genomes.custom[genomeId]) !== null && _state$genomes$custom !== void 0 ? _state$genomes$custom : (_state$genomes2 = state.genomes) === null || _state$genomes2 === void 0 ? void 0 : _state$genomes2.public[genomeId];
  };
};
export default createMemoizedSelector(getGenomeById);